import React from 'react';
const carouselImages = ['https://cdn.magicpatterns.com/uploads/nVuho3TuekwEUHmJa3LR5G/frutillas_cubierto_de_202604231456.jpg', 'https://cdn.magicpatterns.com/uploads/gMEmwRHgRtddnKm3gwevh6/chocolate_blanco_en_202604231454.jpg', 'https://cdn.magicpatterns.com/uploads/v9HyqBcFrasWVwvS7vf1gE/mujer_de_30_202604231452.jpg', 'https://cdn.magicpatterns.com/uploads/iMrZ1Y6SSVHRJymF9hLmJr/bonbones_y_chocolate_202604231448.jpg'];
export function PainSection() {
  const painPoints = [{
    icon: '😰',
    title: 'El chocolate no brilla',
    desc: 'Invertiste en insumos, tardaste horas y el bombón salió opaco o pegado al molde.'
  }, {
    icon: '📱',
    title: 'Nadie para en tu foto',
    desc: 'Subís a Instagram con todo el amor y el silencio es ensordecedor. Cero preguntas de precio.'
  }, {
    icon: '💸',
    title: '"Es muy caro"',
    desc: 'Te dicen eso cuando sabés que cada peso está justificado. No ven el valor.'
  }, {
    icon: '📈',
    title: 'La inflación te come',
    desc: 'Los insumos suben cada semana y no sabés cómo ajustar precios sin perder clientes.'
  }, {
    icon: '😔',
    title: 'Ves a otras y no entendés',
    desc: 'Emprendedoras con agenda llena y miles de seguidores. ¿Qué tienen que vos no?'
  }, {
    icon: '🤯',
    title: 'No sabés por dónde empezar',
    desc: 'YouTube, grupos de Facebook, tutoriales contradictorios. Mucha info, ningún sistema.'
  }];
  return <section className="bg-negro-suave py-10 px-5 text-center" data-id="element-107">
      <div className="max-w-[900px] mx-auto" data-id="element-108">
        <p className="text-[12px] tracking-[3px] uppercase text-oro-rosa mb-2 font-bold" data-id="element-109">
          ¿Te identificás con esto?
        </p>
        <h2 className="font-playfair text-[clamp(22px,3.5vw,34px)] mb-6 text-blanco" data-id="element-110">
          Sabemos exactamente cómo te sentís cuando...
        </h2>
        <div className="grid grid-cols-2 md:grid-cols-3 gap-3" data-id="element-111">
          {painPoints.map((point, index) => <div key={index} className="bg-gradient-card border border-[rgba(201,149,108,0.2)] rounded-xl p-4 text-left transition-all duration-300 hover:border-oro-rosa hover:-translate-y-1 hover:shadow-[0_10px_25px_rgba(201,149,108,0.15)]" data-id="element-112">
              <div className="text-2xl mb-2" data-id="element-113">{point.icon}</div>
              <h3 className="text-[14px] text-oro-rosa-claro mb-1.5 font-bold" data-id="element-114">
                {point.title}
              </h3>
              <p className="text-[13px] text-[#aaaaaa] leading-[1.5]" data-id="element-115">
                {point.desc}
              </p>
            </div>)}
        </div>
      </div>

      <div className="mt-8 overflow-hidden w-full" data-id="element-116">
        <div className="flex gap-4 animate-marquee w-max" data-id="element-117">
          {[...carouselImages, ...carouselImages].map((src, i) => <img key={i} src={src} alt="" className="h-[180px] md:h-[220px] w-auto rounded-xl object-cover flex-shrink-0" data-id="element-118" />)}
        </div>
      </div>
    </section>;
}